import { VNLOADER_SET_SPINNER } from './ActionTypes'

const getInitialState = () => {
  return {
    show: false,
    text: '',
  }
}

export default function reducer(state = getInitialState(), action) {
  switch (action.type) {
    case VNLOADER_SET_SPINNER:
      return {
        ...state,
        show: action.payload.show,
        text: action.payload.text,
      }
    default:
      return state
  }
}
